import React from 'react';
import { Divider } from '@vibe/core';
import LeaveTypeManager from '../leave/LeaveTypeManager';
import LeaveApproverPanel from './LeaveApproverPanel';

/**
 * Combined Leave Settings panel — shows Leave Types and Leave Approvers
 * as two sections within a single settings tab.
 */
const LeaveSettingsPanel: React.FC = () => (
  <div className="rp-leave-settings">
    <LeaveTypeManager />
    <Divider className="rp-leave-settings__divider" />
    <LeaveApproverPanel />
  </div>
);

export default LeaveSettingsPanel;
